// extracted by mini-css-extract-plugin
module.exports = {"Incrementer":"Incrementer_Incrementer__1k0LB","Value":"Incrementer_Value__3_SBa"};